import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, RTL_LANGS } from "../lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("royce_lang") || "en");

  useEffect(() => {
    localStorage.setItem("royce_lang", lang);
    const rtl = RTL_LANGS.includes(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback(
    (key) => {
      const table = translations[lang] || translations.en;
      const val = table[key];
      if (val !== undefined) return val;
      return translations.en[key] !== undefined ? translations.en[key] : key;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
